import { CancelToken } from 'axios';

import { TransferAPI } from '../api/transfer';

import Logger from '@module/logger';
import request from '@module/http/axios/request';

// async/queue checks if the provided worker is an asyncFunction or not.
// Because of ES5 transpilation, this function will not be asynchronous on browsers,
// and the queue will pass a callback that must be called to be able to
// "resolve" or "reject" the task.
export async function processChunkTask(chunk, callback = null) {
  try {
    // Check if the file size changed before trying to upload the chunk
    if (chunk.file.didFileSizeChange()) throw new Error('FileSizeChanged');

    chunk.setUploadTime();

    const response = await requestUploadUrl(chunk);
    await uploadChunk(chunk, response.url);

    // All good, the chunk has been uploaded!
    chunk.uploadComplete();

    // Notify the queue that this task is done without errors
    if (callback) return callback(null, chunk);
    return chunk;
  } catch (error) {
    // Notify the queue that this task could not be processed
    if (callback) return callback(error);
    throw error;
  }
}

function requestUploadUrl(chunk) {
  Logger.log(
    `[${chunk.file.name}] Retrieve upload url for part #${chunk.partNumber}`
  );

  return TransferAPI.fetchPartPutUrl(
    chunk.transferId,
    chunk.fileId,
    {
      chunk_number: chunk.partNumber + 1, // offset by 1
      chunk_size: chunk.content.size,
      // TODO: remove this required field from the backend
      chunk_crc: 0,
      retries: chunk.attempts,
    },
    //retries
    {
      limit: 10,
    }
  );
}

function uploadChunk(chunk, path) {
  const content = chunk.content;
  chunk.cancelToken = CancelToken.source();

  Logger.log(
    `[${chunk.file.name}] Uploading ${content.size} bytes for part #${chunk.partNumber}`
  );

  return request({
    method: 'put',
    path,
    params: content,
    cancelToken: chunk.cancelToken.token,
    onUploadProgress(progressEvent) {
      // Measure the bytes sent at this stage.
      // TODO: avoid references to file here and execute a callback instead
      chunk.file.state.bytesProgress[chunk.partNumber] = Math.round(
        (progressEvent.loaded / progressEvent.total) * content.size
      );
    },
  });
}
